export const translations = {
  en: {
    nav: {
      about: "About",
      contact: "Contact",
      home: "Home",
      portfolio: "Portfolio",
      charart: "Character Art"
    },
    about: {
      text: ""
    }
  },
  es: {
    nav: {
      about: "Sobre mí",
      contact: "Contactos",
      home: "Inicio",
      portfolio: "Portafolio",
      charart: "Personajes"
    },
    about: {
      text: ""
    }
    // langToggle: "EN"
  }

}